export default __webpack_public_path__ + "static/media/art.aeeb76d9.PNG";